interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, index) => index + 1);

  return (
    <nav className="flex items-center justify-center gap-2 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="h-9 px-3 rounded-md border border-background-200 text-sm text-foreground-700 flex items-center gap-1 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-left-s-line text-lg"></i>
        </span>
        上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={[
            "w-9 h-9 rounded-md text-sm flex items-center justify-center transition-colors cursor-pointer",
            page === current
              ? "bg-primary-500 text-background-50"
              : "border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600",
          ].join(" ")}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="h-9 px-3 rounded-md border border-background-200 text-sm text-foreground-700 flex items-center gap-1 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        下一页
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-right-s-line text-lg"></i>
        </span>
      </button>
    </nav>
  );
}